import { Component, OnInit } from '@angular/core';
import { Pages } from '../core/constants/shared.constants';
import { ActivatedRoute } from '@angular/router';
import { MenuItem } from '../core/interfaces/menu-items';

@Component({
  selector: 'app-voice-inbound',
  templateUrl: './voice-inbound.component.html',
  styleUrls: ['./voice-inbound.component.scss']
})
export class VoiceInboundComponent implements OnInit {

  public module: string = "";
  public title: string = "";
  public menuItems: MenuItem[];

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.module = this.route.snapshot.data.module;
    this.title = this.route.snapshot.data.menuTitle;
    this.getMenuItems();
  }

  private getMenuItems() {
    this.menuItems = [
      {
        title: 'Overview',
        url: `/voice-in/${Pages.Overview}`
      },
      {
        title: "Phone number",
        url: `/voice-in/did`
      },
      {
        title: 'Application phone',
        url: `/voice-in/application-phone`,
        children: [
          {
            title: 'Webhook',
            url: `/voice-in/application-phone/webhook`
          },
          {
            title: 'Json text',
            url: `/voice-in/application-phone/json-text`
          },
          {
            title: 'Json editor',
            url: `/voice-in/application-phone/json-editor`
          },
        ]
      },
      {
        title: 'Channel behavior',
        url: `/voice-in/channel-behavior`,
        children: [
          {
            title: 'Play',
            url: `/voice-in/channel-behavior/play`
          },
          {
            title: 'Say',
            url: `/voice-in/channel-behavior/say`
          },
          {
            title: 'Dial',
            url: `/voice-in/channel-behavior/dial`
          },
          {
            title: 'TrunkDial',
            url: `/voice-in/channel-behavior/trunk-dial`
          },
          {
            title: 'Menu',
            url: `/voice-in/channel-behavior/menu`
          },
          {
            title: 'Collect',
            url: `/voice-in/channel-behavior/collect`
          },
          {
            title: 'CollectSpeech',
            url: `/voice-in/channel-behavior/collect-speech`
          },
          {
            title: 'AskAssistant',
            url: `/voice-in/channel-behavior/ask-assistant`
          },
          {
            title: 'AskGenerativeAI',
            url: `/voice-in/channel-behavior/ask-ai`
          },
          {
            title: 'Redirect',
            url: `/voice-in/channel-behavior/redirect`
          },
          {
            title: 'SetVariable',
            url: `/voice-in/channel-behavior/set-variable`
          },
          {
            title: 'Condition',
            url: `/voice-in/channel-behavior/condition`
          },
          {
            title: 'Silence',
            url: `/voice-in/channel-behavior/silence`
          },
          {
            title: 'Record',
            url: `/voice-in/channel-behavior/record`
          },
          {
            title: 'Conference',
            url: `/voice-in/channel-behavior/conference`
          },
          {
            title: 'AgentConference',
            url: `/voice-in/channel-behavior/agent-conference`
          },
          {
            title: 'AgentPhone',
            url: `/voice-in/channel-behavior/agent-phone`
          },
          {
            title: 'RemoteAgent',
            url: `/voice-in/channel-behavior/remote-agent`
          },
          {
            title: 'AgentGroup',
            url: `/voice-in/channel-behavior/agent-group`
          },
          {
            title: 'Storage',
            url: `/voice-in/channel-behavior/storage`
          },
          {
            title: 'HttpRequest',
            url: `/voice-in/channel-behavior/httprequest`
          },
          {
            title: 'GoTo',
            url: `/voice-in/channel-behavior/go-to`
          },
          {
            title: 'AppendNodes',
            url: `/voice-in/channel-behavior/append-nodes`
          },
          {
            title: 'Sms',
            url: `/voice-in/channel-behavior/sms-request`
          },
          {
            title: 'Email',
            url: `/voice-in/channel-behavior/email-request`
          },
          {
            title: 'Whatsapp',
            url: `/voice-in/channel-behavior/whatsapp-request`
          }
        ]
      },
      {
        title: "Voice call statistics",
        url: `/voice-in/inbound-history`
      },
      {
        title: "Get data storage for a voice call",
        url: `/voice-in/${Pages.StorageDetails}`
      },
      {
        title: "Rephrase with ChatGPT",
        url: `/voice-in/${Pages.RephraseInstructions}`
      }
    ];
  }

}
